import { registerPlugin, WebPlugin } from "@capacitor/core";

/**
 * Bridge to the app-local `CohesiveShareAuth` Swift plugin, which mirrors the
 * Auth0 access token into the shared Keychain so the iOS Share Extension can
 * call the Cohesive API directly (see user-mobile ios/App/Shared/SharedAuthStore.swift).
 */
export interface CohesiveShareAuthPlugin {
  setCredentials(options: {
    accessToken: string;
    apiBaseUrl: string;
  }): Promise<void>;
  clearCredentials(): Promise<void>;
}

/** Web stub — mirroring only exists (and only matters) on native iOS. */
class CohesiveShareAuthWeb
  extends WebPlugin
  implements CohesiveShareAuthPlugin
{
  async setCredentials(): Promise<void> {}
  async clearCredentials(): Promise<void> {}
}

export const CohesiveShareAuth = registerPlugin<CohesiveShareAuthPlugin>(
  "CohesiveShareAuth",
  { web: () => new CohesiveShareAuthWeb() },
);
